import { render, staticRenderFns } from "./RoleDialog.vue?vue&type=template&id=ed5f32c2&"
import script from "./RoleDialog.vue?vue&type=script&lang=js&"
export * from "./RoleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports